// Export jQuery as CommonJS and default ES Module exports. This way our own
// code can do `import $ from "jquery"` and legacy npm modules can still do
// `var $ = require("jquery")`. Unfortunately this requires monkey patching the
// jQuery object but it probably does not matter at all (unless there's a jQuery
// plugin named "default")
window.jQuery.default = window.jQuery;
module.exports = window.jQuery;
